function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8299 6.96509H5.00014C4.47012 6.96656 3.96223 7.17776 3.58745 7.55254C3.21267 7.92732 3.00147 8.43521 3 8.96523V19.9452C3 20.2902 3.18 20.6099 3.47014 20.7951C3.63 20.8949 3.81514 20.9451 3.99986 20.9451C4.14986 20.9451 4.29986 20.9099 4.44 20.8452L9.93514 18.1649H14.8401C15.37 18.1634 15.8777 17.9522 16.2524 17.5775C16.6271 17.2028 16.8383 16.6951 16.8399 16.1652V8.96523C16.8384 8.43529 16.6272 7.92746 16.2526 7.55269C15.8779 7.17792 15.3701 6.96667 14.8401 6.96509H14.8299ZM14.8299 14.3549V16.1652H9.69514C9.54514 16.1652 9.39514 16.1999 9.255 16.2651L4.995 18.3449V8.96566H14.8299V14.3549Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.15479 5.00014V6.00986H9.15493V5.00014H19.0001V12.9999H17.8001V15H19.0001C19.53 14.9984 20.0378 14.7872 20.4125 14.4124C20.7872 14.0376 20.9983 13.5298 20.9998 12.9999V5.00014C20.9983 4.4702 20.7872 3.96237 20.4125 3.5876C20.0378 3.21283 19.53 3.00158 19.0001 3H9.15493C8.62491 3.00147 8.11702 3.21267 7.74224 3.58745C7.36746 3.96223 7.15626 4.47012 7.15479 5.00014Z",
  fill: "white"
});

var SvgQueriesAndComplaintsSidebar = function SvgQueriesAndComplaintsSidebar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQueriesAndComplaintsSidebar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/queries_and_complaints_sidebar.ff649393.svg";
export { ForwardRef as ReactComponent };